import { render } from "./TgPayment.vue?vue&type=template&id=a9a8a95a&scoped=true"
import script from "./TgPayment.vue?vue&type=script&lang=js"
export * from "./TgPayment.vue?vue&type=script&lang=js"

import "./TgPayment.vue?vue&type=style&index=0&id=a9a8a95a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a8a95a"]])

export default __exports__